import {HideAllLinesCommand} from "slotworks/commands/lines/hide-all-lines-command";
import {StaticSymbolsCommand} from "slotworks/commands/symbols/static-symbols-command";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import {showPFSSummary} from "../../../commands/promo-free-spins/show-pfs-summary";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import GameState from "slotworks/model/game-state";

export default class Idle extends State {

    private BetMenuMediator: BetMenuMediator;

    public onEnter() {
        showPFSSummary();
        SmartButton.setFlag(SmartButtonFlag.IDLE, true);

        this.BetMenuMediator = new BetMenuMediator();
        this.BetMenuMediator.start().execute();
        Regulation.updateNetPosition(GameState.getNetPosition());
    }

    public onSkip() {
        this.skip();
    }

    public onExit() {
        StaticSymbolsCommand().execute();

        this.BetMenuMediator.end();

        HideAllLinesCommand().execute();

        SmartButton.setFlag(SmartButtonFlag.IDLE, false);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/idle.ts